import './styles/main.css';
import { ensureAppSession } from './api/auth.js';
import { renderBookingForm } from './components/booking-form.js';

// Global Diagnostic Error Boundary
window.addEventListener('error', (e) => {
  console.error('Quick Bookings Runtime Exception:', e);
  const appRoot = document.getElementById('app') || document.body;
  appRoot.innerHTML = `
    <div class="max-w-md mx-auto my-12 p-6 bg-slate-900 border border-rose-500/30 rounded-3xl text-center space-y-4 shadow-2xl">
      <div class="text-3xl">⚠️</div>
      <h2 class="text-lg font-bold text-white">Temporary System Glitch</h2>
      <p class="text-xs text-slate-400 leading-relaxed">
        We encountered an unexpected error while initializing. Please try reloading the page.
      </p>
      <div class="flex justify-center pt-2">
        <button onclick="localStorage.clear(); location.reload();" class="px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-xl text-xs font-bold transition">
          Reload Page
        </button>
      </div>
    </div>
  `;
});

async function initializeQuickBookings() {
  const appRoot = document.getElementById('app');
  if (!appRoot) return;

  // Pulse loader while headless authentication and catalog hydrate
  appRoot.innerHTML = `
    <div class="min-h-screen flex flex-col items-center justify-center p-4">
      <div class="flex items-center gap-3 text-slate-400 text-xs font-medium animate-pulse">
        <span class="w-2.5 h-2.5 rounded-full bg-blue-500 animate-ping"></span>
        <span>Loading Available Services & Live Schedule...</span>
      </div>
    </div>
  `;

  try {
    // 1. Headless authentication using service credentials (no login form)
    await ensureAppSession();

    // 2. Render minimal standalone consumer shell
    appRoot.innerHTML = `
      <div class="min-h-screen flex flex-col justify-between py-6 px-3 sm:px-6">
        <header class="max-w-4xl mx-auto w-full mb-6 flex items-center justify-between">
          <div class="flex items-center gap-2.5">
            <div class="w-9 h-9 rounded-xl bg-blue-600/10 border border-blue-500/20 flex items-center justify-center text-lg">
              🛠️
            </div>
            <div>
              <h1 class="text-base sm:text-lg font-black text-white tracking-tight leading-none">Major Maker</h1>
              <span class="text-[10px] text-slate-400 font-medium">Quick Bookings</span>
            </div>
          </div>
        </header>

        <main id="booking-mount" class="flex-1 w-full"></main>

        <footer class="max-w-4xl mx-auto w-full mt-10 pt-4 border-t border-slate-800/60 text-center text-[11px] text-slate-500">
          <p>&copy; ${new Date().getFullYear()} Major Maker LTD. All rights reserved.</p>
        </footer>
      </div>
    `;

    // 3. Mount the booking form
    const bookingMount = document.getElementById('booking-mount');
    await renderBookingForm(bookingMount);

  } catch (err) {
    console.error('Quick Bookings Boot Fault:', err);
    appRoot.innerHTML = `
      <div class="max-w-md mx-auto my-16 p-6 bg-slate-900/90 border border-slate-800 rounded-3xl text-center space-y-4 shadow-xl">
        <div class="text-3xl">🛠️</div>
        <h2 class="text-lg font-bold text-white">Booking Portal Offline</h2>
        <p class="text-xs text-slate-400 leading-relaxed">
          We were unable to connect to the scheduling gateway. Please check back shortly or reload.
        </p>
        <div class="pt-2">
          <button onclick="location.reload();" class="px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-xl text-xs transition shadow-lg shadow-blue-600/30">
            Retry Connection
          </button>
        </div>
      </div>
    `;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeQuickBookings);
} else {
  initializeQuickBookings();
}